import React from 'react'
import { Helmet } from 'react-helmet'

const Meta = ({ title, description, keywords }) => {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name='description' content={description} />
            <meta name='keyword' content={keywords} />
        </Helmet>
    )
}


Meta.defaultProps = {
    title: 'Cartão Virtual Sesc Alagoas',
    description: 'Cartão Virtual On-line do Sesc Alagoas',
    keywords: 'Sesc, Alagoas, Poço, Guaxuma, Arapiraca',
}


export default Meta